import { ISalesLink } from '../../types/offersData';
import { IApplicationState } from '../../types/redux';

export const getSalesLinks = (state: IApplicationState): ISalesLink[] => {
  return state.offersData.salesLinks || [];
};
